import { ActionIcon, Tooltip } from '@mantine/core'
import { Pencil, Trash2 } from 'lucide-react'

interface ActionsCellProps {
  template: {
    taskTemplateId: string
    title: string
    createdAt: string
    updatedAt: string
    createdBy?: {
      firstName: string
      lastName: string
    }
  }
  onEdit: (template: any) => void
  onDelete: (template: any) => void
}

const ActionsCell = ({ template, onEdit, onDelete }: ActionsCellProps) => {
  return (
    <div className="flex flex-row items-center gap-4 ">
      <Tooltip label="Edit">
        <Pencil
          size={14}
          className="text-doubleNickel-gray-600 hover:text-doubleNickel-gray-500"
          onClick={(e) => {
            e.stopPropagation()
            onEdit(template)
          }}
        />
      </Tooltip>
      <Tooltip label="Delete">
        <Trash2
          size={14}
          className="text-red-500 hover:text-red-400"
          onClick={(e) => {
            e.stopPropagation()
            onDelete(template)
          }}
        />
      </Tooltip>
    </div>
  )
}

export default ActionsCell
